import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

import { KibButtonNew } from '@chewy/kib-controls-react';
import { KibChipAction } from '@chewy/kib-chips-react';

import { ArrowIcon } from '@src/components/icons/arrow';
import { ChewyCarePlusLogo } from '@src/components/icons/chewy-heath-careplus';
import { CircleImageModifier } from '@src/components/circle-image-modifier';

import { useRouteUtils } from '@src/hooks/use-route-utils.hook';

import WindowService from '@src/services/window.service';

export default function Note({
  onFetchPlansClicked,
  onLinkClicked,
  onSectionView,
}: {
  onFetchPlansClicked: (label: string, value: string) => void;
  onLinkClicked: (
    label: string,
    value: string,
    extraData: Record<string, string>,
  ) => void;
  onSectionView: (
    label: string,
    value: string,
    extraData?: Record<string, string>,
  ) => void;
}) {
  const [NoteSectionRef, NoteSectionInview] = useInView({
    triggerOnce: true,
  });
  const [fetchPlansRef, fetchPlansInView] = useInView({
    triggerOnce: true,
  });

  const { getInternalPath } = useRouteUtils();

  useEffect(() => {
    if (NoteSectionInview) {
      onSectionView(
        'herewhenyou<span>(andyourpet)</span>needitmost.',
        'Here when you <span>(and your pet)</span> need it most.',
      );
    }
  }, [NoteSectionInview]);

  useEffect(() => {
    if (fetchPlansInView) {
      onSectionView('bottomFetchPlans', 'Fetch Plans');
    }
  }, [fetchPlansInView]);

  return (
    <section className="pi-careplus__note">
      <div className="pi-careplus__note--image">
        <CircleImageModifier
          imgSrc="/pet-insurance/img/owner-staring-contest-with-bulldog.png"
          accPos="left"
          lazy={true}
        />
      </div>

      <div className="pi-careplus__note--content">
        <ChewyCarePlusLogo />

        <h2 className="pi-careplus__note--title" ref={NoteSectionRef}>
          Here when you <span>(and your pet)</span> need it most.
        </h2>

        <div className="pi-careplus__note--fetch" ref={fetchPlansRef}>
          <KibButtonNew
            onClick={() => {
              onFetchPlansClicked('bottomFetchPlans', 'Fetch Plans');
            }}
            size="large"
          >
            Fetch Plans
          </KibButtonNew>

          <hr className="divider" />

          <div className="pi-careplus__quote--skip">
            <span className="pi-careplus__quote--legend">
              Already enrolled?
            </span>

            <div className="pi-careplus__quote--action">
              <KibChipAction
                icon={<ArrowIcon />}
                variant="transparent"
                href={getInternalPath(
                  `${WindowService.base}/policies/dashboard`,
                )}
                onClick={() => {
                  onLinkClicked(
                    'bottomManageYourPolicy',
                    'Manage Your Policy',
                    {
                      url: getInternalPath(
                        `${WindowService.base}/policies/dashboard`,
                      ),
                    },
                  );
                }}
              >
                Manage Your Policy
              </KibChipAction>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
